import { useMutation } from "@tanstack/react-query";
import {
  deleteStrandLoss,
  justifyStrandLoss,
  upsertStrandLoss,
} from "../../repositories/StrandLossesManagerRepository";

interface UpsertStrandLossParams {
  strandLossId: number | null;
  assetId: number;
  start: Date | null;
  end: Date | null;
  strandLossCodeId: number | null;
  strandLossCategoryId: number | null;
  comments: string | null;
}

interface JustifyStrandLossParams {
  strandLossId: number;
  strandLossCodeId: number | null;
  strandLossCategoryId: number | null;
  comments: string | null;
}

export const useUpsertStrandLossMutation = () =>
  useMutation({
    mutationFn: async (params: UpsertStrandLossParams) => {
      const response = await upsertStrandLoss(
        params.strandLossId,
        params.assetId,
        params.start,
        params.end,
        params.strandLossCodeId,
        params.strandLossCategoryId,
        params.comments,
      );
      if (!response.ok) throw new Error(response.message);
      return response;
    },
  });

export const useJustifyStrandLossMutation = () =>
  useMutation({
    mutationFn: async (params: JustifyStrandLossParams) => {
      const response = await justifyStrandLoss(
        params.strandLossId,
        params.strandLossCodeId,
        params.strandLossCategoryId,
        params.comments,
      );
      if (!response.ok) throw new Error(response.message);
      return response;
    },
  });

export const useDeleteStrandLossMutation = () =>
  useMutation({
    mutationFn: async (strandLossId: number) => {
      const response = await deleteStrandLoss(strandLossId);
      if (!response.ok) throw new Error(response.message);
      return response;
    },
  });
